// Services.js
import React, { useMemo } from 'react';
import { 
  FaPassport, 
  FaGraduationCap, 
  FaHome, 
  FaUsers,
  FaBuilding,
  FaHeadset,
  FaArrowRight
} from 'react-icons/fa';
import './Services.css';
import { Link } from 'react-router-dom';

const Services = () => {
  // Services mémoïsés pour éviter les recréations
  const services = useMemo(() => [
    {
      id: 1,
      title: "Accompagnement Visa",
      description: "Assistance complète pour l'obtention de votre visa étudiant avec un taux de réussite de 74%.",
      icon: <FaPassport />,
      link: "/service/accompagnement-visa"
    },
    {
      id: 2,
      title: "Admission Universitaire",
      description: "Accès à plus de 60 universités françaises partenaires pour vos études supérieures.",
      icon: <FaGraduationCap />,
      link: "/service/admission-universitaire"
    },
    {
      id: 3,
      title: "Hébergement Étudiant",
      description: "Réservation dans l'une de nos 160 résidences étudiantes partenaires en France.",
      icon: <FaHome />,
      link: "/service/hebergement-etudiant"
    },
    {
      id: 4,
      title: "Intégration Sociale",
      description: "Aide à l'intégration avec nos associations et événements dédiés aux étudiants.",
      icon: <FaUsers />,
      link: "/service/integration-sociale"
    },
    {
      id: 5,
      title: "Partenariats Entreprises",
      description: "Accès à plus de 35 entreprises françaises partenaires pour stages et emplois.",
      icon: <FaBuilding />,
      link: "/service/partenariats-entreprises"
    },
    {
      id: 6,
      title: "Support Continu",
      description: "Suivi personnalisé tout au long de votre parcours académique en France.",
      icon: <FaHeadset />,
      link: "/service/support-continu"
    }
  ], []);

  return (
    <section className="services-section" id="services">
      <div className="services-bg-pattern"></div>
      
      <div className="services-container">
        <div className="services-header">
          <span className="services-badge">Nos services</span>
          <h2 className="services-title">
            Un accompagnement complet
            <span className="services-title-highlight"> pour réussir vos études</span>
          </h2>
          <p className="services-subtitle">
            Des solutions sur mesure pour chaque étape de votre parcours académique en France
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              className="service-card" 
              key={service.id}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="service-card-icon">
                {service.icon}
                <div className="service-card-icon-bg"></div>
              </div>
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-description">{service.description}</p>
              <Link to={service.link} className="service-card-link">
                <span>En savoir plus</span>
                <FaArrowRight />
              </Link>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <Link to="/servicesall" className="services-cta-button">
            Explorer tous nos services
            <FaArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;